export const EmployeeLabels = {
  Employee: "Employee",
  Employees: "Employees",
  TotalEmployee: "Total Employee",
  ActiveEmployee: "Active Employee",
  InActiveEmployee: "In Active Employee",
  DeletedEmployee: "Deleted Employee",
  LastName: "Last Name",
  FirstName: "First Name",
  Email: "Email",
  OfficialEmailId: "Official Email Id",
  AssignTo: "Assign to",
  Technology: "Technology",
  ITPProject: "ITP Project",
  ITPCourse: "ITPCourse",
  Senior: "Senior",
  Junior: "Junior",
  ReAllocation: "Re Allocation",
  RemainingLeave: "Remaining Leave",
  AssignSenior: "Assign Senior",
  Password: "Password",
  PhoneNo: "Phone Number",
  DateOfJoining: "Date Of Joining",
  Role: "Role",
  InactiveUser: "InActive User",
  ViewProfile: "View Profile",
  AssignITP: "Assign ITP",
  EmployeeName: "Employee Name",
  EmployeeDesignation: "Employee Designation",
  EmployeeStatus: "Employee status",
  EmployeeRegistration: "Employee Registration",
  ActiveConfirmation: "you want to Active the Employee ?",
  InactiveConfirmation: "you want to Inactive the Employee ?",
  HRNote: "* Designates that this user is HR.",
  BDENote: "* Designates that this user is BDE.",
  PersonalDetails: "Personal Details",
  PersonalEmail: "Personal Email",
  Gender: "Gender",
  DateOfBirth: "Date Of Birth",
  Nationality: "Nationality",
  Religion: "Religion",
  AddressDetails: "Address Details",
  AddressLine1: "Address Line1",
  AddressLine2: "Address Line2",
  Country: "Country",
  State: "State",
  City: "City",
  OfficeDetails: "Office Details",
  SkypeEmail: "Skype ID (Email)",
  OfficialEmail: "OfficialEmail",
  EmergencyDetails: "Emergency Details",
  PrimaryEmergencyContact: "Primary Emergency Contact",
  Name: "Name",
  Relation: "Relation",
  PrimaryContact: "Primary Contact",
  SecondaryContact: "Secondary Contact",
  SecondaryEmergencyContact: "Secondary Emergency Contact",
  BankName: "Bank Name",
  AccountHolderName: "Account Holder Name",
  AccountNumber: "Account Number",
  IFSCCode: "IFSC Code",
  CollegeName: "College Name",
  Qualification: "Qualification",
  Year: "Year",
  EmployeeProfile: "Employee Profile",
  EmployeeId: "Employee Id",
  ReportTo: "Report To",
  EmergencyConctact: "Emergency Contact",
  BankInformation: "Bank Information",
  EducationInformation: "Education Information",
  UpdateProfile: "Update Profile",
  DocumentType: "Document Type",
  UpdateDate: "Update Date",
  Education: "Education",
  AadharCard: "Aadhar Card",
  PanCard: "Pan Card",
  DrivingLicense: "Driving License",
  ResourceName: "Resource Name",
  ResourceID: "Resource ID",
  AllocatedDate: "Allocated Date",
  SubmittedDate: "Submitted Date",
  Date: "Date",
  LeaveType: "Leave Type",
  NumberOfDays: "Number of Days",
  Reason: "Reason",
  Profile: "Profile",
  PassingYear: "Passing Year",
  File: "File",
  AadharCardNumber: "Aadhar Card Number",
  Number: "Number",
  Upload: "Upload",
  Developer: "Developer",
  EditProfile: "Edit Profile",
  Overview: "Overview",
  Resources: "Resources",
  Documents: "Documents",
  Info: "Info",
  BankDetail: "Bank Detail",
  EmployeeLeave: "Employee Leave",
  CasualLeave: "Casual Leave",
  CompOffLeave: "Comp Off Leave",
  LeaveWithoutPay: "Leave Without Pay",
};
